var React = require('react');

function ProcessButtonCircle (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-618 -2231)"},[React.createElement("g",{"transform":"translate(618 2231)","fill":"rgba(27,252,190,0.32)","stroke":"rgba(255,255,255,0.16)","strokeMiterlimit":"10","key":0},[React.createElement("circle",{"cx":"16","cy":"16","r":"16","stroke":"none","key":0}),React.createElement("circle",{"cx":"16","cy":"16","r":"15.5","fill":"none","key":1})]),React.createElement("circle",{"data-name":"Oval","cx":"12","cy":"12","r":"12","transform":"translate(622 2235)","fill":"#fff","key":1}),React.createElement("circle",{"data-name":"Oval 02","cx":"9","cy":"9","r":"9","transform":"translate(625 2238)","fill":"none","stroke":"rgba(184,184,184,0.56)","strokeMiterlimit":"10","key":2})]));
}

ProcessButtonCircle.defaultProps = {"width":"32","height":"32"};

module.exports = ProcessButtonCircle;

ProcessButtonCircle.default = ProcessButtonCircle;
